module.exports = __webpack_public_path__ + "img/close-nero-grey.85337261.svg";